module.exports = __webpack_public_path__ + "img/cs-baseSucc-1.07ce1c1c.jpg";